var _g, _path, _path2, _path3, _path4, _g2, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAnnouncement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 124,
    viewBox: "0 0 128 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Image"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 10884"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M95.2743 65.9893C93.2993 51.6443 85.7743 39.9894 85.7743 39.9894C63.1843 0.399364 57.1786 12.4247 54.0486 16.9897C53.6236 17.6047 53.2786 18.2697 52.9986 18.9647C45.7743 52.4897 7.2836 57.4734 7.2836 57.4734C7.2836 57.4734 -3.0614 60.0134 2.8686 72.4384L4.2486 75.1134C0.733601 77.2584 -0.521399 81.7984 1.4736 85.4534C3.4086 88.9984 7.7036 90.4284 11.3386 88.8684L11.5436 89.2684C12.0836 90.3184 12.7886 91.2734 13.6536 92.0834C13.6686 92.0984 13.6836 92.1084 13.6986 92.1234C16.0686 94.3234 19.2736 95.2584 22.3686 94.8084C26.4136 102.983 32.6386 113.408 40.8786 120.903C46.6686 126.168 53.3886 121.163 55.1986 119.813C58.7436 117.178 60.3036 112.158 56.8786 109.368C52.4736 105.778 48.3236 105.203 43.0086 99.1684C49.6086 94.7884 51.3586 86.4934 51.7936 81.5634C56.7786 79.5784 61.4636 78.3884 67.1436 78.3084C79.6536 78.1334 90.2136 80.4784 91.6736 80.2584C95.3036 79.7134 96.6393 75.9043 95.2743 65.9893ZM35.9786 88.7734C38.6436 87.5034 41.4636 86.1734 44.1836 84.9184C42.7936 90.3684 40.1936 92.6434 38.7886 93.5034C37.8886 92.1084 36.9536 90.5384 35.9786 88.7734Z",
    fill: "#00175A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M86.0243 37.8107C86.0243 37.8107 93.7993 52.7157 95.7743 67.0607C97.1393 76.9757 95.2936 79.785 91.6636 80.33C90.2036 80.55 79.6436 78.205 67.1336 78.38C61.4536 78.46 56.7687 79.65 51.7837 81.635C44.2743 84.6252 43.0243 85.5609 36.2743 88.94L22.3586 94.88C19.2636 95.33 16.0587 94.395 13.6887 92.195C13.6737 92.18 13.6587 92.17 13.6437 92.155C12.7787 91.345 12.0737 90.39 11.5336 89.34L11.3286 88.94C10.2644 87.3109 9.76441 86.8109 8.01441 83.0609C6.2644 79.3109 5.78864 78.475 4.23865 75.185L2.85865 72.51C-3.07135 60.085 7.27365 57.545 7.27365 57.545C7.27365 57.545 23.0243 51.989 32.2743 46.739C43.5243 38.239 48.346 30.1485 53.2743 18.073C53.5543 17.378 53.8993 16.713 54.3243 16.098C57.4543 11.533 63.4343 -1.77934 86.0243 37.8107Z",
    fill: "#006FCF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 151",
    d: "M89.0263 15.6643L95.9905 2.73898",
    stroke: "#EA700B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 152",
    d: "M106.024 50.2516L121.858 52.4812",
    stroke: "#EA700B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_348_8707",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 10,
    width: 96,
    height: 85
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M86.0243 37.8111C86.0243 37.8111 93.7993 52.7161 95.7743 67.0611C97.1393 76.9761 95.2937 79.7854 91.6637 80.3304C90.2037 80.5504 79.6437 78.2054 67.1337 78.3804C61.4537 78.4604 56.7687 79.6504 51.7837 81.6354C44.2743 84.6256 43.0243 85.5613 36.2743 88.9404L22.3587 94.8804C19.2636 95.3304 16.0587 94.3954 13.6887 92.1954C13.6737 92.1804 13.6587 92.1704 13.6437 92.1554C12.7787 91.3454 12.0737 90.3904 11.5337 89.3404L11.3286 88.9404C10.2644 87.3113 9.76441 86.8113 8.01441 83.0613C6.26441 79.3113 5.78864 78.4754 4.23865 75.1854L2.85865 72.5104C-3.07135 60.0854 7.27365 57.5454 7.27365 57.5454C7.27365 57.5454 23.0243 51.9894 32.2743 46.7394C37.3911 42.8734 41.1781 39.0921 44.2501 34.982C47.9324 30.0555 50.5875 24.6567 53.2743 18.0734C53.5543 17.3784 53.8993 16.7134 54.3243 16.0984C57.4543 11.5334 63.4343 -1.77889 86.0243 37.8111Z",
    fill: "#006FCF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_348_8707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 154",
    opacity: 0.1,
    d: "M31.6785 58.6391C58.3384 61.9161 68.4689 68.4198 75.0299 80.1282C86.5387 100.666 74.0218 115.756 64.6292 122.695C36.7645 142.226 -21.7911 166.099 -33.0959 105.343C-47.2268 29.3973 -32.5938 14.1118 -19.8424 17.6796C-10.7094 20.235 5.39825 55.4087 31.6785 58.6391Z",
    fill: "#ECEDEE"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 153",
    d: "M105.5 30.0005L125.476 21.9398",
    stroke: "#EA700B",
    strokeWidth: 4,
    strokeLinecap: "round"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.94939e14b65dfc4e7b490bcab28ef87f.svg";
export { ForwardRef as ReactComponent };